import { render, staticRenderFns } from "./RelatedTime.vue?vue&type=template&id=2e0a1629&"
import script from "./RelatedTime.vue?vue&type=script&lang=js&"
export * from "./RelatedTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports